import type { ContentType, Note } from '../domain/note'
import { urlContentCategory } from '../domain/urlCategory'

export type SearchProperty = 'image' | 'video' | 'audio' | 'article' | 'social'

export function matchesContentTypeFilter(
  note: Note,
  contentType: ContentType | 'all' | undefined,
): boolean {
  if (!contentType || contentType === 'all') return true
  if (contentType === 'image') return note.assetIds.length > 0
  return note.contentType === contentType
}

/**
 * User-facing search properties describe what a capture contains, rather than
 * exposing the app's internal content-type taxonomy. Images may be attached to
 * any note; the remaining properties come from the canonical URL classifier.
 */
export function matchesSearchProperty(
  note: Note,
  property: SearchProperty | undefined,
): boolean {
  if (!property) return true
  if (property === 'image') return note.assetIds.length > 0
  return note.urls.some((url) => urlContentCategory(url, note.contentType) === property)
}
